import * as React from "react";
import ReactDOM from "react-dom";
export function renderLogoutIframe(url: string | undefined) {
	const renderTarget = document.getElementById("idam_logout_iframe_container");
	const iframe = <iframe width="0" height="0" src={url} />;

	if (renderTarget != null) {
		ReactDOM.render(iframe, renderTarget);
	}
}
